export class PagedRequest {
  pageNumber: number
  pageSize: number
  sortField?: string
  sortDirection?: 'asc' | 'desc'

  constructor(
    pageNumber: number,
    pageSize: number,
    sortField?: string,
    sortDirection?: 'asc' | 'desc'
  ) {
    this.pageNumber = pageNumber
    this.pageSize = pageSize
    this.sortField = sortField
    this.sortDirection = sortDirection
  }
}